import { ActionDef } from '../Actions/ActionDef'

const gridStoreStates = {
    listViewAddRecordFrom: false, // if true - popup opened when clicked on add record button (new record mode), if false - popup opened when row is clicked (edit record mode); used to show/hode next/previous button on popup
    advanceListviewStateJson: undefined,  // used to store the current advance listview subform json in designer when advance listview detailed page is opened
    currentAdvanceListviewStateJson: undefined, // used to store the current advance listview json in preview when advance listview popup is opened
    subFormListviewJson: undefined,
    openCanvasForPreview: false, // used to check if advance Listview/button subform/listview popup is opened or not in preview mode
    openCanvasForPreviewAdvance: false, // used to check if advance Listview popup is opened or not in preview mode
    listviewClearState: false, // used to clear the local state of the listview controls
    advSaveAndContinue: false, // used to render table when "save and continue" button is clicked on advance listview
    selectedTableRow: {}, // used in open-transaction to get selected table and listview rows
    globalError: { isError: false, message: "" }, // used to display error message when table has duplicate value error and user tries to save workitem
    dataOfAdvFrom: new Map(), // used to disable the advanced listview popup buttons when child table has duplicate value error
    selectedRowIndex: -1, // used to get selected row index of listview
    selectedRowIndexAdvance: -1, // used to get selected row index of advance listview
    spareAdvanceListviewStateJson: undefined, // used to store advanced listview state in designer of exact time when detailed page is opened.
    spareAdvListviewPopupStyle: undefined, // used to store advanced listview popup style in designer of exact time when detailed page is opened.
    spareListviewPopupStyle: undefined, // used to store listview popupstyle in designer of exact time when subform is opened.
    showListviewPopupProperties: false,
    showAdvListviewPopupProperties: false, 
    triggerFetchGridData: { count: 0, action: "" },
    gridBatchBtnStyles: new Map()
    // currentadvanceListview: undefined // used to store the current advance listview json in designer when advance listview detailed page is opened
}

const marvinStoreStates = {
    openMarvinModal: false,
    marvinButtonSelected: false,
    marvinFormJson: {},
    marvinRequestSent: false,    
    isMarvinEnabled: false,  
    renamePageSubform:{
        pageRename: false,
        subformRename: false,
        NewName: ""
    }
}
const emptyContext={
    key:"default",
    generalData:{},
    formstate:{},
    routeJourneySelectionPage:"",
    contexts:{
        mandatoryControls: [],
        activeStepName: '',
        activeSubStepName: '',
        activeStepId: '',
        windowScreenObjects: [],
        activeSubStepId: '',
        // updateJson: {},
        formState2: {},
        imageBaseURL: "",
        populateFormStateFromJsonOnAction: function(){},
        applicationNameObj: {
            applicationName: "",
            formName: ""
        },
        activeMenuId: null,
        setActiveMenuId: function(){},
        subFormMetaData: [],
        formJsonFromMataData: {},
        subformStack: [false],
        setSubformStack: function(){},
        currentListviewForSubform: undefined,
        setCurrentListviewForSubform: function(){},
        isTableBackdropOpen: false,
        setIsTableBackdropOpen: function(){},
        listviewFrameLayoutJsonClone_listviewMap: "",
        onDragStartOfSubform: function(){},
        elementToCreate: function(){},
        targetElemState: {
            targetId: "",
            targetClass: "",
            targetElemType: "",
            frameIndex: "",
            targetRowId: "",
            targetColId: "",
            targetColParentId: "",
            elementIndex: "",
            sheetIndex: "",
            sheetElementIndex: "",
        },
        onDragOfSubform: function(){},
        testClick: function(){},
        targetForDrop: function(){},
        drop: function(){},
        applyChanges: function(){},
        dragging: false,
        setDragging: function(){},
        deleteControl: function(){},
        changeSectionLayout: function(){},
        showProperties: false,
        setShowProperties: function(){},
        quickToolsClose: false,
        setQuickToolsClose: function(){},
        formState2: {},
        updateColumnWidth: function(){},
        handleReorderStart: function(){},
        handleReorderDrop: function(){},
        selected: {
            id: "",
            tempStatus: "",
        },
        setSelected: function(){},
        addColumn: function(){},
        device: "web",
        updateJson: {
            updatedComponentInFormState: function(){},
            removeAndUpdateComponentInFormState: function(){},
            saveFormState: function(){},
        },
        showDataAdditionSection: false,
        setShowDataAdditionSection: function(){},
        draggedObjType: "",
        customControlIdList: [],
        setCustomControlIdList: function(){},
        setCurrElem: function(){},
        setSubFormState: function(){},
        setFormState2: function(){},
        isPortal: false,
        handleCustomControlId: function(){},
        changeCanvasLayout: function(){},
        selectedControl: { elem_type: "" },
        setSelectedControl: function(){},
        draggedFrom: "",
        setDraggedFrom: function(){},
        openDrawer: false,
        setOpenDrawer: function(){},
        drawerPinned: false,
        setDrawerPinned: function(){},
        propertyPinned: false,
        setPropertyPinned: function(){},
        openProperties: false,
        setOpenProperties: function(){},
        showAlertConfirmNotifications: function(){},
        alertResponseMessage: function(){},
        setAlertResponseMessage: function(){},
        widthOfCanvasArea: "",
        setWidthOfCanvas: function(){},
        isMenuSubMenuAdded: false,
        setIsMenuSubMenuAdded: function(){},
        dataObjectJson: {},
        setDataObjectJson: function(){},
        dataObjects: {},
        setDataObjects: function(){},
        isMicroSerciceChecks: {
            IsMicroserviceMode: "N",
            MicroAuthParam: null,
            MicroAuthToken: null,
        },
        setisMicroSerciceChecks: function(){},
        templateForm: false,
        setFormTemplate: function(){},
        activePage: "",
        setActivePage: function(){},
        activeSubForm: "",
        setActiveSubForm: function(){},
        activeApplication: undefined,
        showPagesSubForms: false,
        setShowPagesSubForms: function(){},
        allPages: [],
        setAllPages: function(){},
        allSubForms: [],
        setSubForms: function(){},
        setApplicationScreenshot: function(){},
        setActiveApplication: function(){},
        mappingDataObjectsMap: new Map(),
        DataObjectsArray: [],
        handleValueForConditionalVisibility: function(){},
        valueForConditionalVisibility: {},
        openLoader: false,
        setOpenLoader: function(){},
        toggleProperty: false,
        setToggleProperty: function(){},
        loginErrorPage: false,
        setLoginErrorPage: function(){},
        globalTime: {},
        setGlobalTime: function(){},
        sessionPopupTime: {},
        setSessionPopupTime: function(){},
        sessionTime: "",
        setSessionTime: function(){},
        formBuillderMode: "",
        successAndErrorMessageControlsListBasedOnAttribute:
          {},
        handleSuccessAndErrorMessageControlsListBasedOnAttribute:
          function(){},
        builderMode: "",
        setFormBuillderMode: function(){},
        applicationData: {},
        setApplicationData: function(){},
        getElementJson: function(){},
        headerJSON: {
            id: "LoginHeader",
            elem_type: "LoginHeader",
            style: {},
        },
        setHeaderJSON: function(){},
        loggedInUserData: {
            loggedInUserName: "",
            lastLoggedInTime: "",
        },
        setLoggedInUserData: function(){},
        setMapValue: function(){},
        MapValue: "",
        MapId: "",
        setMapId: function(){},
        mappingControlsMap: new Set(),
        mappingControlsIdMap: new Set(),
        dataObjectsContent: {},
        setDataObjectsContent: function(){},
        recursiveJsonForImportSection: function(){},
        addColsToControlsForDataObjects: function(){},
        addColumnObj: function(){},
        addRowObj: function(){},
        currentButtonForSubform: undefined,
        setCurrentButtonForSubform: function(){},
        currentadvanceListview: undefined,
        getDeviceFromProps_mf: false,
        setCurrentadvanceListview: function(){},
        latestChangesSaved: true,
        setLatestChangesSaved: function(){},
        listviewColumnInfo: new Map([]),
        setlistviewColumnInfo: function(){},
        clearMap: function(){},
        addToMap: function(){},
        containerId: "default",
        openQuickToolFor: undefined,
        setOpenQuickToolFor: function(){},
        handleSubForm: function(){},
        openCanvasForSubform: false,
        showSubForm: false,
        setShowSubForm: function(){},
        allNonFilledMandatoryFields: [],
        setAllNonFilledMandatoryFields: function(){},
        setAllNonFilledMandatoryFieldsFunc: function(){},
        sectionInitiallyCollapsedState: {},
        setSectionInitiallyCollapsedState: function(){},
        allGridControlsIds: new Map(),
        setOpenMF: function(){},
        openMF: false,
        loginHeaderHeight: 0,
        setLoginHeaderHeight: function(){},
        canvasTop: 0,
        setCanvasTop:function(){},
        spareListviewStateJson: "",
        setSpareListviewStateJson: function(){},
        modeReadOrWrite: "W",
        maskingData: new Map(),
        maskingKeys: [],
        parentChildCustom: "",
        setParentChildCustom: "",
        dataClassAdvacnceListview: "",
        setDataClassAdvacnceListview: function(){},
        recursiveJsonForMapping: function(){},
        MapType: "",
        setMapType: function(){},
        subFormStateJson: "",
        spareSubForm: "",
        setSpareSubForm: function(){},
        setSubform_obj: function(){},
        setCurrentDataObjectJson: function(){},
        microFrontendComponentType: "",
        microFrontendData: {},
        appId: "",
        formMataData: undefined,
        isApp: function(){},
        processId: "",
        statusType: "",
        openingAsApplication: {},
        setSelectedDataObject: function(){},
        selectedDataObject: '',
        setSelectedItem: function(){},
        selectedItem: "",
        setCurrentMappedDO: function(){},
        currentMappedDO: [],
        webServiceResponse: "",
        setwebServiceResponse: function(){},
        filteredDataObject: [],
        setfilteredDataObject: function(){},
        setOpen1: function(){},
        setSeverity: function(){},
        setSeverityMessage: function(){},
        transactionId: 0,
        setTransactionId: function(){},
        setIsStep: function(){},
        isStep: {},
        setEventList: function(){},
        eventList: 0,
        setSelectedButtonEventId: function(){},
        selectedButtonEventId: "",
        setSubformElementIndex: function(){},
        setfromQuickProps: function(){},
        fromQuickProps: false,
        setCopyElement: function(){},
        copyElement: {},
        setfilteredDataObjectCopy: function(){},
        filteredDataObjectCopy: [],
        setRecordCount: function(){},
        recordCount: new Map(),
        appname: "",
        errorState: [],
        setTableRowData: function(){},
        tableRowData: {},
        recursiveJsonReaderForSubForm: function(){},
        max_ColumnValue: window.max_ColumnValue,
        max_RowValue: window.max_RowValue,
        setMax_controlIdValue: function(){},
        setUpdateDataObject: function(){},
        updateDataObject: false,
        fetchDataObject: function(){},
        setIsButtonSubformOpen: function(){},
        isButtonSubformOpen: false,
        cabinetName: "",
        setAlertData: function(){},
        setCurrentSubFormInWizard: function(){},
        setGlobalLoading: function(){},
        globalLoading: false,
        wizard_type_step: "-1",
        wizard_type_subStepIndex: "-1",
        subWizard_type_step: "-1",
        subWizard_type_subStepIndex: "-1",
        wizard_type_subChildMenuIndex: "-1",
        set_wizard_type_step: function(){},
        set_wizard_type_subStepIndex: function(){},
        set_wizard_type_subChildMenuIndex: function(){},
        set_subWizard_type_step: function(){},
        set_subWizard_type_subStepIndex: function(){},
        set_subWizard_type_stepId: function(){},
        set_subWizard_type_subStepId: function(){},
        set_wizard_type_stepId: function(){},
        set_wizard_type_subStepId: function(){},
        wizard_type_stepId: "",
        wizard_type_subStepId: "",
        subWizard_type_stepId: "",
        subWizard_type_subStepId: "",
        setGlobalLoadingMessage: function(){},
        globalLoadingMessage: false,
        setListviewInfoUpdated: function(){},
        listviewInfoUpdated: false,
        // setListviewModifyMode: function(){},
        // listviewModifyMode: false,
        parentWizardCheck: function(){},
        parentTab: function(){},
        parentMenuCheck:function(){},
        isTaskForm: false,
        QueryString: "",
        themeOpen: false,
        setThemeOpen: function(){},
        themeResetDone:false,
        setThemeResetDone:function(){},
        fixedFooter:false,
        setFixedFooter: function(){},
        setThemeResetValDone:function(){},
        themeResetValDone:false,
        isLoginTypeVar: false,
        setSelectionPage: function(){},
        selectionPage: "",
        updateDataObjectAfterCreate:function(){},
        landscapeView : "",
        homePage: ""
    },
    gdtoken:"",
    wizard_stage:"",
    witoken:"",
    isWorkItem:"",
    pid:"",
    fullScreenMode: false,
    formMataData:undefined,
    hoverColumn: false,
    dragDropDO: false,
    frameDOChild: {},
    sectionKeyFieldData: [],
    noOfRows: 0, 
    controlSelected: false,
    gridStates: gridStoreStates,
    marvinStates: marvinStoreStates,
    routeCriteriaApplied: false,
    loginPortal: "N",
    loadingState: {
    open: false,
    message: "",
    displayLoader: true,
    displayBackdrop: true
  }
}

const emptyContext2={
    key:"default",
    gridStates: gridStoreStates
}

const marvinEmptyContext={
    key:"",
    marvinStates: marvinStoreStates
}

const initialState = {
    "containerInfo":{
        containerId:"default",
        containerIndex:0,
    },
    "data":[
        {
            key:"default",
            generalData:{},
            formstate:{},
            routeJourneySelectionPage:"",
            contexts:emptyContext.contexts,
            gdtoken:"",
            wizard_stage:"",
            witoken:"",
            isWorkItem:"",
            pid:"",
            formMataData:undefined,
        }
    ],
    "data2": [
        {
            key: "default",
            gridStates: gridStoreStates,
        }
    ],
    "marvinData": [
        {
            key: "default",
            marvinStates: marvinStoreStates,
        }
    ],
    callHomePage: false,
    postChangeFormLang_samepage : false,
    wizard_updated_height : 0,
    renderElements: new Map(),
    controlSelected: false,
    hoverColumn: false,
    dragDropDO: false,
    noOfRows: 0,
    tempCanWidth: 0,
    renderAdvanceListView: false,
    tempCanWidthDesignPage: 0,
    tempCanHeightDesignPage: 0,
    devicePreview:'',
    doclistRerenderCount: false,
    renderListView: false,
    mandatoryControls: [],
    mandatoryControls1: [],
    dataObjectsContent: {},
    renderCanvas: false,
    parentWizardHeight: 0,
    tempCanHeight: 0,
    appScreenshotSavedDetails:[],
    iformClientLoaded: false,
    iformClientLoadedButtonSubform: false,
    renderSection: false,
    isDesigner: false,
    resetProperties:false,
    resetNoteTheme:false,
    openSubformCheck:false,
    tabActiveIndex:{},
    generalDataCall: false,
    afterFormLoad: false,
    pageLoaded: true,
    saveload:false,
    displaySheets: undefined,
    openDoclistViewerMicro: false,
    clearDoclist: '',
    // openDoclistUploadMicro: false,
    isButtonProperties: '',
    listOfDataObjects: [],
    bfProcessName: '',
    isBFChanged: 'false',
    templateLoaded: false,
    alertStack: [],
};

export const formStateReducer = (state = initialState, action) => {
    // action?.payload?.key is containerID
    const key = action?.payload?.key ? action?.payload?.key : state?.containerInfo?.containerId;
    var updatedState=state.data.find(data => data?.key ===key);
    if(updatedState===undefined){
        const emptyContextJson={...emptyContext};
        emptyContextJson.key= key;
        updatedState=emptyContextJson;
        state.data.push(updatedState);
    }
    var index;
    if(!key)
        index = state.containerInfo.containerIndex;
    else index=state.data.findIndex(data => data.key === key);
    if(index===undefined){
        index=state.data.length;
    }

    var updatedState2=state.data2.find(data => data?.key ===key);
    if(updatedState2===undefined){
        const emptyContextJson2={...emptyContext2};
        emptyContextJson2.key= key;
        updatedState2=emptyContextJson2;
        state.data2.push(updatedState2);
    }

    var index2=state.data2.findIndex(data => data.key === key);
    if(index2===undefined){
        index=state.data2.length;
    }
    
    let marvinUpdatedState = state.marvinData.find((data) => data?.key === key);
    if (marvinUpdatedState === undefined) {
      const marvinEmptyContextJson = { ...marvinEmptyContext };
      marvinEmptyContextJson.key = key;
      marvinUpdatedState = marvinEmptyContextJson;
      state.marvinData.push(marvinUpdatedState);
    }
  
    const marvinIdex = state.marvinData.findIndex((data) => data.key === key);
    if (marvinIdex === undefined) {
      index = state.marvinData.length;
    }

    switch (action.type) {
        case "CONTAINERINFO":
            return{
                ...state, "containerInfo": {"containerId": key , "containerIndex":index }
            }
        case "updateStore":
            updatedState={...updatedState, [action.payload.name]:action.payload.value };
            state.data.splice(index,1,updatedState)
            return{
                ...state
            };
        case "RESET_ERROR_STATE":
              updatedState={...updatedState,
                    "contexts": {...updatedState.contexts, "errorState":[] } }
                state.data.splice(index,1,updatedState);
                return {
                    ...state
                };        
        case "RESET":
            const contextData1 = state.data;
            contextData1.forEach((val,index) => {
                if(contextData1[index].key === key)
                    contextData1[index] = {...emptyContext, key: key,contexts: {...emptyContext.contexts, formState2: action.payload.formState}};
                // return val;
            })
            const contextData2 = state.data2;
            contextData2.forEach((val,index) => {
                if(contextData2[index].key === key)
                    contextData2[index] = {...emptyContext2, key: key};
                // return val
            })
            state = {...initialState};
            if(action.payload.resetContainerId)
                state.containerInfo = {...state.containerInfo, containerId: key, containerIndex: index}
            state.data = contextData1;
            state.data2 = contextData2;
            return {...state};

        case "updateTabActiveIndex": 
            state.data[index].contexts.tabActiveIndex = {...state.data[index].contexts.tabActiveIndex, [action.payload.name]: action.payload.value};
            return state;
        case "ADDCONTEXTS":
                updatedState={...updatedState, [action.payload.name]: {...updatedState.contexts,...action.payload.contextValues} };
                state.data.splice(index,1,{...updatedState})
                console.log("ADDCONTEXTS",state, action.payload);
                // return state
                return {
                    ...state
                };
        // case "ADDCONTEXTS":
        //     const updatedData = [...state.data]; // Create a shallow copy of `state.data`
        //     updatedData[index] = { 
        //         ...updatedData[index], // Copy the existing item
        //         contexts: {
        //             ...updatedData[index].contexts, // Copy the contexts object
        //             formState2: action.payload // Update only formState2
        //         }
        //     };
        
        //     return { 
        //         ...state, // Keep the state reference the same
        //         data: updatedData // Update only the data reference
        //     };

        case "UPDATECONTEXTS":
            // updatedState={...updatedState, 
            //     "contexts": {...updatedState.contexts, [action.payload.name]:action.payload.value } }
            // state.data.splice(index,1,updatedState);
            // return {
            //     ...state
            // }
            return {
                ...state,
                data: state.data.map((item, i) =>
                  i === index
                    ? {
                        ...item, // Keep other properties
                        contexts: {
                          ...item.contexts, // Keep other context properties
                          [action.payload.name]:action.payload.value
                        }
                      }
                    : item
                )
              };
        case "updateFormStateWithoutRender":  
            state.data[index].contexts.formState2 = action.payload;
            return state
        case "updateWindowScreenObjectsWithoutRender":  
            state.data[index].contexts.windowScreenObjects = [...state.data[index].contexts.windowScreenObjects, action.payload.value];
            return state
        case "updateFormStateWithRender":
            return {
                ...state,
                data: state.data.map((item, i) =>
                  i === index
                    ? {
                        ...item, // Keep other properties
                        contexts: {
                          ...item.contexts, // Keep other context properties
                          formState2: { ...action.payload } // Update formState2
                        }
                      }
                    : item
                )
              };
        case "SET_MAP":
            const { tableId, newData } = action.payload;
            // updatedState={...updatedState, 
            //     "contexts": {...updatedState.contexts, listviewColumnInfo: {
            //         ...updatedState.contexts.listviewColumnInfo, // Keep existing tables
            //         [tableId]: {
            //           ...(updatedState.contexts.listviewColumnInfo[tableId] || {}), // If tableId doesn't exist, create a new object
            //           ...newData, // Update new column data
            //         },
            //       },}}
             // Clone the current tableMap
            const newTableMap = new Map(updatedState.contexts.listviewColumnInfo);

            // If the tableId doesn't exist, initialize it with a new Map
            if (!newTableMap.has(tableId)) {
                newTableMap.set(tableId, new Map());
            }

            // Get the Map for the specific tableId and update it
            const tableData = newTableMap.get(tableId);
            Object.entries(newData).forEach(([key, value]) => {
                tableData.set(key, value); // Add new data to the table's Map
            });
            console.log("inside formStateReducer setMap", newTableMap, tableData)
            updatedState={...updatedState, 
                "contexts": {...updatedState.contexts, listviewColumnInfo: newTableMap, } }
            state.data.splice(index,1,updatedState);
            console.log("inside formStateReducer setMap1", state, updatedState)
            return state
            // return {
            //     ...state,
            //     data: state.data.map((item, i) =>
            //       i === index
            //         ? {
            //             ...item, // Keep other properties
            //             contexts: {
            //               ...item.contexts, // Keep other context properties
            //               listviewColumnInfo: newTableMap
            //             }
            //           }
            //         : item
            //     )
            //   };
        case "CLEAR_MAP":
            // updatedState={...updatedState, 
            //     "contexts": {...updatedState.contexts, listviewColumnInfo: new Map(), } }
            // state.data.splice(index,1,updatedState);
            // return {...state}
            return {
                ...state,
                data: state.data.map((item, i) =>
                  i === index
                    ? {
                        ...item, // Keep other properties
                        contexts: {
                          ...item.contexts, // Keep other context properties
                          listviewColumnInfo: new Map()
                        }
                      }
                    : item
                )
              };
        case "updateFormStateContextWithoutRender":  
            state.data[index].contexts[action.payload.name] = action.payload.value;
            return state
        case "updatesubFormMetaDataWithoutRender":  
            if(!state.data[index].contexts["subFormMetaData"]?.includes(action.payload.value))
                state.data[index].contexts["subFormMetaData"] = [...state.data[index].contexts["subFormMetaData"],action.payload.value];
            return state
        case "removeSubFormMetaDataWithoutRender":  
            if(state.data[index].contexts["subFormMetaData"]?.includes(action.payload.value)) {
                state.data[index].contexts["subFormMetaData"] = state.data[index].contexts["subFormMetaData"]?.filter((item) => item !== action.payload.value);
            }
            return state
        case "updateStateInRedux":  
            // state[action.payload.name] = action.payload.value;
            // return {...state}
            return {
                ...state,
                [action.payload.name]: action.payload.value
            };
        case "ADD_NEW_ALERT":  
            return {
                ...state,
                alertStack: [...state.alertStack, action.payload]
            };
        case "REMOVE_ALERT":  
            return {
                ...state,
                alertStack: state.alertStack.filter((alert) => alert !== action.payload)
            };
        case "UPDATE_RENDER_ELEMENT":
            if(action.payload.id){
                const newRenderElements = new Map(state.renderElements);
                newRenderElements.set(action.payload.id, action.payload.value)
                console.log("inside updaterenderElement reducer", newRenderElements, action.payload.id)
                return { ...state, renderElements: newRenderElements }; // ✅ Returning new state object
            }
            return state;
        case "DELETE_RENDER_ELEMENT": 
            if (state.renderElements.has(action.payload)) {
                const newRenderElements = new Map(state.renderElements);
                newRenderElements.delete(action.payload);
                
                console.log("inside deleterenderElement reducer", newRenderElements);
                return { ...state, renderElements: newRenderElements }; // ✅ Returning new state object
                // state.renderElements = newRenderElements
                // return state;
            }
            return state;
        case "UPDATE_GRID_CONTEXTS":
            updatedState2={...updatedState2, "gridStates":{...updatedState2.gridStates, [action.payload.name]: action.payload.value}}
            state.data2.splice(index,1,updatedState2);
            if(action.payload.renderAdvListView) {
                state.renderAdvanceListView  = new Date();                
            }
            if(action.payload.renderListView) {
                state.renderListView = new Date();
            }
            if(action.payload.renderCanvas && state.isDesigner) {
                state.renderCanvas = new Date();
            }
            // state.data2[index].gridStates[action.payload.name] = {...state.data2[index].gridStates,...action.payload.value};
            return {...state}

        case "UPDATE_ADV_DATA":
            const { id, colIndex, rowIndex } = action.payload.value;
            const dataOfAdvFrom = updatedState2.gridStates.dataOfAdvFrom;
            const columnRowIndex = `${colIndex}.${rowIndex}.`;

            if(action.payload.action === "add") {
                if(dataOfAdvFrom.has(id)) {
                    const gridSet = dataOfAdvFrom.get(id);
                    gridSet.add(columnRowIndex);
                } else {
                    const newSet = new Set();
                    newSet.add(columnRowIndex);
                    dataOfAdvFrom.set(id, newSet);
                }
            } else if(action.payload.action === "checkAndRemove") {
                if(dataOfAdvFrom.has(id)) {
                    let gridSet = dataOfAdvFrom.get(id);
                    if(gridSet.has(columnRowIndex)) {
                        gridSet.delete(columnRowIndex);

                        if(gridSet.size === 0) {
                            dataOfAdvFrom.delete(id);

                            if(action.payload.renderAdvListView) {
                                state.renderAdvanceListView  = new Date();
                            }
                        }
                    }
                }
            }

            state.data2.splice(index, 1, updatedState2);
            return { ...state };
        case "UPDATE_MARVIN_CONTEXTS":
            marvinUpdatedState = {
                ...marvinUpdatedState,
                marvinStates: { ...marvinUpdatedState.marvinStates, ...action.payload.states }
            };
            state.marvinData.splice(index, 1, marvinUpdatedState);

            if (action.payload.renderSectionForm) {
                state.renderSectionForm = new Date();
            }
            if (action.payload.renderListView) {
                state.renderListView = new Date();
            }
            if (action.payload.states.renderCanvas && state.isDesigner) {
                state.renderCanvas = new Date();
            }
            if (action.payload.renderCanvas && state.isDesigner) {
                state.renderCanvas = new Date();
            }
            if (action.payload.renderSection && state.isDesigner) {
                state.renderSection = new Date();
            }
            if (action.payload.renderDesignerHeader) {
                state.renderDesignerHeader = new Date();
            }
            if (action.payload.renderPageSubform) {
                state.renderPageSubform = new Date();
            }
            return { ...state };
            case "UPDATE_ERROR_STATE":
                if(updatedState.contexts.errorState?.includes(action.payload.name))
                    return {
                        ...state
                    };
                updatedState={...updatedState,
                    "contexts": {...updatedState.contexts, "errorState": [...updatedState.contexts.errorState,action.payload.name] }
                    };
                state.data.splice(index,1,updatedState);
                return {
                    ...state
                };
        case "UPDATE_REMOVE_ERROR_STATE":
                    if (updatedState.contexts.errorState?.includes(action.payload.name)) {
                        updatedState = {
                            ...updatedState,
                            contexts: {
                                ...updatedState.contexts,
                                errorState: updatedState.contexts.errorState.filter(
                                    (id) => id !== action.payload.name
                                ),
                            },
                        };
                        state.data.splice(index, 1, updatedState);
                        return {
                            ...state,
                        };
                    }
                
        
        case ActionDef.GET_FORM_STATE:
            return {
                ...state
            }; 

        case ActionDef.UPDATE_FORM_STATE:
            updatedState={...updatedState, formstate:action.payload };
            state.data.splice(index,1,updatedState)
            return {
                ...state
            };

        case "updateFormStateContext":
                updatedState={...updatedState, 
                    "contexts": {...updatedState.contexts, "formState2":action.payload.value } }
                state.data.splice(index,1,updatedState);
                return {
                    ...state
                };

        case ActionDef.SET_FORM_STATE:
            //return setFormState(state,action.payload);

            updatedState={...updatedState, formstate:action.payload };
            state.data.splice(index,1,updatedState)
            return {
                ...state
            };

        case ActionDef.SET_GENERAL_DATA:
            updatedState={...updatedState, generalData:action.payload };
            state.data.splice(index,1,updatedState)
            return {
                ...state
            };

        case ActionDef.SET_SELECTION_PAGE:
            updatedState={...updatedState, routeJourneySelectionPage: action.payload.value };
            state.data.splice(index,1,updatedState)
            return {
                ...state
            };

        case ActionDef.SET_APP_SCREENSHOT_SAVED_FLAG:
            return{
                ...state, appScreenshotSavedDetails:action.payload.value
            }

        case ActionDef.Update_Contexts_States:
            // state.data2[index].gridStates = {...state.data2[index].gridStates,...action.payload.value};
            updatedState2={...updatedState2, "gridStates":{...updatedState2.gridStates, ...action.payload.value}}
            state.data2.splice(index,1,updatedState2);
            if(action.payload.renderAdvListView)
                state.renderAdvanceListView  = new Date();
            if(action.payload.renderListView)
                state.renderListView = new Date();
            if(action.payload.renderCanvas && state.isDesigner) {
                state.renderCanvas = new Date();
            }
            // return {...state}
            return state
            // updatedState = {
            //     ...updatedState, 
            //     "gridStates": { ...updatedState.gridStates, ...action.payload.value } 
            // }
            // state.data.splice(index, 1, updatedState);
            // return { ...state };
            case ActionDef.Update_State: 
            state = {...action.payload};
            return {...state};

        default:
            return state;
    }
}

function updateFormState(formState, componentToUpdate){
    //  console.log("formState :: ",formState, "componentToUpdate :: ",componentToUpdate);
    return formState;
}

function setFormState(state,initialState){
    //  console.log('setFormState :: ',initialState);
}
function elementFromFormState(formState, elementId){
    //  console.log('elementFromFormState :: ', formState, elementId);
}